import React, { useEffect, useState } from 'react';
import Main from "../../Main";
import OrgChart from 'react-orgchart';
import 'react-orgchart/index.css';
import '../../../assets/css/organizationChart.scss';
import '../../../assets/css/customermanagement.scss';
import Download from '../../MainSection/Download/Download';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadOrganizationChart } from '../../../redux/action';
import noDataFound from '../../../assets/images/no-data-found.svg';
import Skeleton from 'react-loading-skeleton';

// Custom Node Component
const MyNodeComponent = ({ node }) => {
    return (
        <div className="initechNode">
            <div className="hierarchy-image">
                {/* <img src="https://accounts.metricinfo.com/static/media/Admin1.8437b5803eede29b4bb9.png" alt="Org Chart" /> */}
                {node.ProfileIcon ? (
                    <img
                        src={node.ProfileIcon}
                        alt={node.Name}
                        onError={(e) => e.target.src = "https://accounts.metricinfo.com/static/media/Admin1.8437b5803eede29b4bb9.png"} // Fallback if image fails to load
                    />
                ) : (
                    <img
                        src="https://accounts.metricinfo.com/static/media/Admin1.8437b5803eede29b4bb9.png"
                        alt="Org Chart"
                    />
                )}
            </div>
            <div className="hierarchy-positions">
                <b>{node.Name}</b>
                <p>{node.Designation}</p>
                <p>{node.Department}</p>
                {/* <p>{node.title}</p> */}
            </div>
        </div>
    );
};

const OrganizationChart = () => {
    const dispatch = useDispatch();
    const { getOrganizationChart } = useSelector((state) => state.data);

    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };
    useEffect(() => {
        dispatch(loadOrganizationChart(setLoading));
    }, []);

    // Function to convert API data into the expected format
    // const formatOrgChartData = (data) => {
    //     return data.map(item => ({
    //         ...item,
    //         children: item.Children ? formatOrgChartData(item.Children) : []
    //     }));
    // };

    const formatOrgChartData = (data) => {
        return data.map(item => ({
            ...item,
            children: item.Subordinates ? formatOrgChartData(item.Subordinates) : []
        }));
    };

    // Prepare the tree data
    const orgChartData = getOrganizationChart ? formatOrgChartData(getOrganizationChart) : [];

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Organization Chart"
                        onBackClick={handleBack}
                    />
                </div>

                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <div className='organization-cahrt-container'>
                            <span>Organization Chart</span>
                            <div className="hierarchy-div" id="initechOrgChart">
                                {/* <OrgChart tree={data} NodeComponent={MyNodeComponent} /> */}
                                {loading ? (
                                    <Skeleton count={5} height={40} />
                                ) : orgChartData.length > 0 ? (
                                    orgChartData.map((tree, index) => (
                                        <OrgChart key={index} tree={tree} NodeComponent={MyNodeComponent} />
                                    ))
                                ) : (
                                    <p>
                                        <img src={noDataFound} alt="No Data" style={{ height: "250px", width: "280px" }} />
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Main>
        </div>
    );
}

export default OrganizationChart;
